import { productImageBadgesStyles } from "@insite/content-library/Components/ProductImageBadges";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productImageBadgesStyles.imageItem = {
    css: css`
        padding: 5px;
        justify-content: center;
        max-width: 25%;
    `,
};
